export default "__VITE_ASSET__BLS4eTM5__"